import '@/lib/errorReporter';
import { enableMapSet } from 'immer';
enableMapSet();
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { GameShell } from '@/game/GameShell';
import '@/index.css';

/**
 * A game is one full-screen surface, so there is no router here — the shell owns every state
 * (playing, paused, over) and the canvas fills the viewport. Add routes only if the game genuinely
 * needs separate pages, such as a level select or a leaderboard.
 */

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <GameShell />
    </ErrorBoundary>
  </StrictMode>,
);
